import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './SupportRequest.css';
import SideBar from '../Components/SideBar';
import { FiSearch, FiSliders } from 'react-icons/fi';
import {API_BASE_URL} from "../config.js";
const SupportRequest = () => {
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [requests, setRequests] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [filterStatus, setFilterStatus] = useState("all"); // 'all', 'pending', 'closed'
  const [sortOrder, setSortOrder] = useState("newest"); // 'newest', 'oldest'
  
  const navigate = useNavigate();

  // جلب التذاكر من قاعدة البيانات
 // داخل مكون SupportRequest.jsx
  useEffect(() => {
    fetchRequests(); // الجلب الأولي
    
    // التحديث اللحظي (Polling) لطلبات الدعم كل 5 ثواني
    const interval = setInterval(() => {
      fetchRequests(true); // نمرر متغير true لكي لا يظهر loading
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const fetchRequests = async () => {
    const token = localStorage.getItem("access_token");
    if (!token) {
      navigate("/login");
      return;
    }

    try {
      const res = await fetch(`${API_BASE_URL}/support/`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (res.ok) {
        const data = await res.json();
        const tickets = data.results ? data.results : data;
        setRequests(tickets);
      } else if (res.status === 401) {
        navigate("/login");
      }
    } catch (error) {
      console.error("خطأ في جلب طلبات الدعم:", error);
    }
  };

  // دالة لحساب الوقت المنقضي
  const timeAgo = (dateString) => {
    const now = new Date();
    const past = new Date(dateString);
    const diffMs = now - past;
    const diffMins = Math.round(diffMs / 60000);
    const diffHrs = Math.round(diffMins / 60);
    const diffDays = Math.round(diffHrs / 24);

    if (diffMins < 1) return 'الآن';
    if (diffMins < 60) return `منذ ${diffMins} دقيقة`;
    if (diffHrs < 24) return `منذ ${diffHrs} ساعة`;
    return `منذ ${diffDays} يوم`;
  };

  // تطبيق الفلترة والبحث والترتيب
  const getFilteredRequests = () => {
    let filtered = requests.filter((req) => {
      const matchesSearch = req.user_name.toLowerCase().includes(searchQuery.toLowerCase()) || 
                            req.subject.toLowerCase().includes(searchQuery.toLowerCase());
      
      const isClosed = req.status === 'resolved' || req.status === 'closed';
      const matchesStatus = filterStatus === 'all' || 
                           (filterStatus === 'closed' && isClosed) || 
                           (filterStatus === 'pending' && !isClosed);

      return matchesSearch && matchesStatus;
    });

    // الترتيب
    filtered.sort((a, b) => {
      const dateA = new Date(a.created_at);
      const dateB = new Date(b.created_at);
      return sortOrder === "newest" ? dateB - dateA : dateA - dateB;
    });

    return filtered;
  };

  // الانتقال لصفحة المحادثة الخاصة بالتذكرة
  const openChat = (ticketId) => {
    navigate('/support', { state: { ticketId: ticketId, role: 'admin' } });
  };

  const filteredRequests = getFilteredRequests();

  return (
    <div className="admin-container" dir="rtl">
      <SideBar role='admin' />

      <main className="main-content">
        <header className="top-header">
          <span className="page-title-top">الدعم</span>
        </header>

        <div className="content-wrapper">
          <div className="action-bar">
            {/* زر الفلترة */}
            <div className="filter-container">
              <button 
                className="filter-btn" 
                onClick={() => setIsFilterOpen(!isFilterOpen)}
              >
                <FiSliders size={24} color="#005b9f" />
              </button>

              {isFilterOpen && (
                <div className="filter-popup">
                  <div className="filter-section">
                    <h4>الترتيب</h4>
                    <div className="filter-buttons">
                      <button 
                        className={`outline-btn ${sortOrder === 'newest' ? 'active' : ''}`}
                        onClick={() => setSortOrder('newest')}
                      >الأحدث</button>
                      <button 
                        className={`outline-btn ${sortOrder === 'oldest' ? 'active' : ''}`}
                        onClick={() => setSortOrder('oldest')}
                      >الأقدم</button>
                    </div>
                  </div>
                  
                  <hr className="divider" />
                  
                  <div className="filter-section">
                    <h4>الحالة</h4>
                    <div className="filter-buttons">
                      <button 
                        className={`status-btn closed ${filterStatus === 'closed' ? 'active-filter' : ''}`}
                        onClick={() => setFilterStatus('closed')}
                      >مغلق</button>
                      <button 
                        className={`status-btn pending ${filterStatus === 'pending' ? 'active-filter' : ''}`}
                        onClick={() => setFilterStatus('pending')}
                      >معلق</button>
                      <button 
                        className={`status-btn ${filterStatus === 'all' ? 'active-filter' : ''}`}
                        style={{border: '1px solid #ccc', background: filterStatus === 'all' ? '#eee' : '#fff'}}
                        onClick={() => setFilterStatus('all')}
                      >الكل</button>
                    </div>
                  </div>

                  <hr className="divider" />
                  <div className="filter-actions">
                    <button className="clear-btn" onClick={() => {setFilterStatus('all'); setSortOrder('newest')}}>مسح</button>
                    <button className="apply-btn" onClick={() => setIsFilterOpen(false)}>تطبيق</button>
                  </div>
                </div>
              )}
            </div>

            {/* شريط البحث */}
            <div className="search-bar">
              <input 
                type="text" 
                placeholder="ابحث عن اسم الطبيب أو الموضوع..." 
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
              <FiSearch className="search-icon" size={20} />
            </div>
          </div>

          <h1 className="main-title">طلبات المراسلة</h1>

          {/* قائمة الطلبات */}
          <div className="requests-list">
            {filteredRequests.length === 0 ? (
               <p style={{textAlign: 'center', color: '#777', marginTop: '20px'}}>لا توجد طلبات تطابق بحثك.</p>
            ) : (
              filteredRequests.map((req) => (
                <div 
                  key={req.id} 
                  className="request-card" 
                  onClick={() => openChat(req.id)}
                  style={{ cursor: 'pointer', borderLeft: (req.status === 'resolved' || req.status === 'closed') ? '5px solid #27ae60' : '5px solid #f39c12' }}
                >
                  <h3 className="request-name">{req.user_name} - {req.subject}</h3>
                  <span className="request-time">{timeAgo(req.updated_at || req.created_at)}</span>
                </div>
              ))
            )}
          </div>
        </div>
      </main>
    </div>
  );
};

export default SupportRequest;